/**
 * We take the approach of organizing each “cast member” in a scene within its own file.
 * This is a choice and isn’t required, but it does isolate internal changes/enhancements
 * to these specific “characters.”
 */
import { IcosahedronGeometry, MeshToonMaterial, Mesh, Group } from 'three'
import plasticRings from '../cast/plasticRings'
import Masks from '../cast/masks'
import Coke from '../cast/coke'
import Straws from '../cast/straws'

/**
 * The use of a JavaScript “class” is also a design choice.
 */
class Particles {
  constructor(color) {
    this.group = new Group()
    this.bubbleGeometry = new IcosahedronGeometry(0.3, 1)
    this.bubbleMaterial = new MeshToonMaterial({ color })
    this.materials = [this.bubbleMaterial]

    for (let i = 0; i < 200; i++) {
      let particle
      if (Math.random() < 0.95) {
        particle = new Mesh(this.bubbleGeometry, this.bubbleMaterial)
        particle.reset = function () {
          particle.position.set(Math.random() - 0.5, Math.random() - 0.5, Math.random() - 0.5).normalize()
          particle.position.multiplyScalar(10 + Math.random() * 75)
        }
        particle.reset()
        particle.callback = function () {
          this.reset()
        }
      } else {
        let random = Math.random()
        particle = random < 0.25 ? new plasticRings(0xffffff).group : random < 0.5 ? new Masks().group : random < 0.75 ? new Coke().group  : new Straws().group 
        particle.position.set(Math.random() - 0.5, Math.random() - 0.5, Math.random() - 0.5).normalize()
        particle.position.multiplyScalar(3 + Math.random() * 20)
        particle.reset = function () {
          particle.visible = false
        }
        this.materials = [...this.materials, ...particle.materials]
      }
      particle.callback = function () {
        this.reset()
      }
      this.group.add(particle)
    }
  }
}

export default Particles
